import React, { useEffect, createElement } from 'react';
// Declare fbq on window
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Meta Pixel Code
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      // Use appendChild instead of insertBefore to avoid parentNode error
      b.head.appendChild(t);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1041442422381259');
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-116">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1041442422381259&ev=PageView&noscript=1" data-id="element-117" />
    </noscript>;
}
// Export function to track AddToCart
export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Cena Sin Pensar',
      content_ids: ['53359207874893'],
      content_type: 'product',
      value: 6.99,
      currency: 'USD'
    });
  }
}